import { lazy } from 'react';
import { Route } from 'react-router-dom';

const EmailUrlCallbackPage = lazy(() => import('src/features/auth/EmailUrlCallbackPage/EmailUrlCallbackPage'));
const GoogleRegisterCallback = lazy(() => import('src/features/auth/GoogleRegisterCallback/GoogleRegisterCallback'));

// Routes related to the user authentication - Login, register, etc
export function AuthenticationRoutes() {
  return (
    <>
      <Route path="google/callback" element={<GoogleRegisterCallback />} />
      <Route path="email-verification-callback" element={<EmailUrlCallbackPage />} />
      <Route path="reset-password-callback" element={<EmailUrlCallbackPage />} />
      <Route path="email-change-verification-callback" element={<EmailUrlCallbackPage />} />
    </>
  );
}
